const weightNumber = 10000000;
export const updateLeagueRankID = (league, isFromUserRegion) => {
    league.defaultOrder = isFromUserRegion ? league.defaultOrder - weightNumber : league.defaultOrder;
    return league;
};
//# sourceMappingURL=updateLeagueRankID.js.map